import { render, staticRenderFns } from "./FeedbackButton.vue?vue&type=template&id=45036c88"
import script from "./FeedbackButton.vue?vue&type=script&lang=js"
export * from "./FeedbackButton.vue?vue&type=script&lang=js"
import style0 from "./FeedbackButton.vue?vue&type=style&index=0&id=45036c88&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports